import changeVariantRouteIndex from 'root/src/client/logic/route/actions/changeVariantRouteIndex'

export default index => dispatch => dispatch(changeVariantRouteIndex(index))
